import $clientApi from '@/api/client'
import type { ProductAvailabilityResponse } from '@/composables/qr-menu/types'

export const checkProductAvailability = async (
  productId: string,
  storeId: number,
  menuId: string
): Promise<ProductAvailabilityResponse> => {
  const { data } = await $clientApi.get<ProductAvailabilityResponse>(
    `/../menu/product/${productId}/store/${storeId}/menu/${menuId}/availability`
  )
  return data
}
